package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.browser.document
import org.w3c.dom.events.Event

@Composable
actual fun OnAppBackground(onBackground: () -> Unit) {
    val currentOnBackground by rememberUpdatedState(onBackground)
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            if (document.asDynamic().hidden as? Boolean == true) currentOnBackground()
        }
        document.addEventListener("visibilitychange", listener)
        onDispose { document.removeEventListener("visibilitychange", listener) }
    }
}
